module.exports = __webpack_public_path__ + "static/img/2.d582740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjiancase/2.png
// module id = kii6
// module chunks = 19